"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const date_fns_1 = require("date-fns");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const AssetThumbnailTooltip = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { assetInfo } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, assetInfo && (react_1.default.createElement("div", { className: styles_modules_less_1.default['asset-thumbnail__ctn'] },
        react_1.default.createElement("label", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "FILE DETAILS:"),
        react_1.default.createElement("label", null,
            react_1.default.createElement("span", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "FILE NAME:"),
            react_1.default.createElement("span", null,
                " ", assetInfo === null || assetInfo === void 0 ? void 0 :
                assetInfo.title)),
        react_1.default.createElement("label", null,
            react_1.default.createElement("span", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "ASSET ID:"),
            react_1.default.createElement("span", null,
                " #", assetInfo === null || assetInfo === void 0 ? void 0 :
                assetInfo.assetId)),
        react_1.default.createElement("label", null,
            react_1.default.createElement("span", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "FILE VERSION:"),
            react_1.default.createElement("span", null,
                " ", assetInfo === null || assetInfo === void 0 ? void 0 :
                assetInfo.version)),
        react_1.default.createElement("label", null,
            react_1.default.createElement("span", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "FILE SIZE:"),
            react_1.default.createElement("span", null,
                " ", assetInfo === null || assetInfo === void 0 ? void 0 :
                assetInfo.size)),
        react_1.default.createElement("label", null,
            react_1.default.createElement("span", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "AUTHOR:"),
            react_1.default.createElement("span", null,
                " ", (_a = assetInfo === null || assetInfo === void 0 ? void 0 : assetInfo.uploadedBy) === null || _a === void 0 ? void 0 :
                _a.name)),
        react_1.default.createElement("label", null,
            react_1.default.createElement("span", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "UPLOADED:"),
            react_1.default.createElement("span", null,
                " ",
                (0, date_fns_1.format)((0, date_fns_1.parseISO)(assetInfo === null || assetInfo === void 0 ? void 0 : assetInfo.time), 'dd/MM/yyyy'))),
        react_1.default.createElement("label", null,
            react_1.default.createElement("span", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "PROJECT:"),
            react_1.default.createElement("span", null,
                " ", (_c = (_b = assetInfo === null || assetInfo === void 0 ? void 0 : assetInfo.requirement) === null || _b === void 0 ? void 0 : _b.job) === null || _c === void 0 ? void 0 :
                _c.jobTitle)),
        react_1.default.createElement("label", null,
            react_1.default.createElement("span", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "JOB NO:"),
            react_1.default.createElement("span", null,
                " ", (_e = (_d = assetInfo === null || assetInfo === void 0 ? void 0 : assetInfo.requirement) === null || _d === void 0 ? void 0 : _d.job) === null || _e === void 0 ? void 0 :
                _e.id)),
        react_1.default.createElement("label", null,
            react_1.default.createElement("span", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "OFFICE:"),
            react_1.default.createElement("span", null,
                " ", (_h = (_g = (_f = assetInfo === null || assetInfo === void 0 ? void 0 : assetInfo.requirement) === null || _f === void 0 ? void 0 : _f.job) === null || _g === void 0 ? void 0 : _g.client) === null || _h === void 0 ? void 0 :
                _h.company)),
        react_1.default.createElement("label", null,
            react_1.default.createElement("span", { className: styles_modules_less_1.default['asset-thumbnail__ctn--label'] }, "BRAND:"),
            react_1.default.createElement("span", null,
                " ", (_k = (_j = assetInfo === null || assetInfo === void 0 ? void 0 : assetInfo.requirement) === null || _j === void 0 ? void 0 : _j.job) === null || _k === void 0 ? void 0 :
                _k.brandTitle))))));
};
exports.default = AssetThumbnailTooltip;
